
<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>

          <div class="search-con search-con-top">

            <slot name="new_btn">
              <Button type="primary" @click="startvote" class="search-btn">投票窗口</Button>
            </slot>
            <Button type="error" class="search-btn" @click="votes">排行榜</Button>


          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border :columns="columns" :data="tableData"
                 ></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :loading=true :footer-hide=true
                 :mask-closable=false fullscreen>
            <div class="background">
              <div style="height: 80px;"></div>
              <div style="background-color:rgba(95,7,7,0.5); padding-top:15px;margin-left: 100px;margin-right:100px;margin-bottom: 100px;">
                <!--              <div style="font-size:20px;text-align: center;font-weight:bold;">太仓市首届企业文化建设评选</div>-->
                <div style="font-size:40px;text-align: center;font-weight:bold;color: white;margin-right: 650px;">{{company_name}}</div>
                <div style="margin-right: 60px; margin-top: 100px; float: right;font-size:30px;text-align: center;color: white;" ref="qrCodeUrl">投票二维码</div>

                <div style="height: 600px;text-align: left; margin-top: 25px; margin-left: 300px;" >

                  <Progress vertical :percent="percant" stroke-width="100" hide-info status="active" />

                </div>


                <div style="font-size:40px;text-align: left;font-weight:bold;color: white;margin-left: 330px;margin-bottom: 100px;">{{votecount}}</div>
              </div>
            </div>
          </Modal>
          <Modal v-model="modalVisible" :loading=true :footer-hide=true
                 :mask-closable=false fullscreen>
            <div class="background">
              <div style="height: 100px;"></div>
              <div style="background-color:rgba(95,7,7,0.5); padding-top:15px;margin-left: 100px;margin-right:100px;margin-bottom: 100px;">
                <!--              <div style="font-size:20px;text-align: center;font-weight:bold;">太仓市首届企业文化建设评选</div>-->
                <div style="font-size:40px;text-align: center;font-weight:bold;color: white; margin-bottom: 10px;">太仓市首届企业文化建设评选</div>
                <div style="font-size:20px;text-align: center;font-weight:bold;color: white;"  v-for="item in ranklist">{{item.rank}}、{{item.ptitle}}  {{item.pvote}}票</div>



              </div>
            </div>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

import { getvote,getplist,votechange,getrank } from '@/api/vote.js'
import QRCode from 'qrcodejs2'
export default {

  data () {
    return {
      spinShow:false,
      fullscreenLoading:false,
      pageNum: 1, // 当前页码
      pageSize: 15, // 每页条数
      pageTotal: 0, // 数据总数
      tableData:[],
      ranklist:[],
      votecount:0,
      company_name:'测试有限公司',
      percant:0,
      modalVisible:false,
      modalMap: {
        modalVisible: false,
        modalTitle: "新建"
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,

          align: 'center'
        },
        {
          title: "名称",
          key: "ptitle",

          align: "center",
          sortable: true
        },
        {
          title: "初评分",
          key: "pfraction",
          align: "center",
          sortable: true
        },
        {
          title: "得票数",
          key: "pvote",

          align: "center",
          sortable: true
        },
        {
          title: "投票通道",
          key: "pstate_CN",

          align: "center",
          sortable: true
        },

        {
          title: "操作",
          key: "handle",
          width: 130,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.votestart(params.row.id,'1');
                    }
                  }
                },
                "开启"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.votestart(params.row.id,'0');
                    }
                  }
                },
                "关闭"
              )
            ]);
          }
        }
      ],
    }
  },

  methods: {
    creatQrCode() {

      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: 'https://ljtc.tcrc.com.cn/vote', // 需要转换为二维码的内容
        width: 250,
        height: 250,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    getinfo_time(){
      const that = this;
      this.getvote()
      setTimeout(function () {
        getinfo_time()
      }, 1000)

    },
    changePage(value) {
      this.pageNum = value
      this.getplist()
    },
    // 切换分页
    handlePageSize(value) {
      this.pageSize = value
      this.pageNum = 1

        this.getplist()

    },
    votestart(pid,change){
      this.spinShow = true
      votechange(pid,change).then(res => {
        this.$Message.success(`${res.data.msg}`)
        this.getplist()
        this.spinShow = false
      })
    },
    startvote(){
      this.getvote();
      this.modalMap.modalVisible = true;
      this.creatQrCode();
    },
    votes(){
      this.getrank();
      this.modalVisible = true;
      // this.creatQrCode();
    },
    getrank(key) {
      const that = this;
      getrank().then(res => {
        if (res.data.code === 0) {
          this.ranklist = res.data.data

        } else {

          this.$Message.error(`${res.data.msg}`)
        }
      })



    },
    getplist(key, value) {
      // console.log(this.columns[7].filters)
      this.spinShow = true
      getplist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {

          this.pageTotal = res.data.count
          this.tableData = res.data.data

        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getvote(key) {
      const that = this;
      getvote(1).then(res => {
        if (res.data.code === 0) {
          this.votecount = res.data.data[0].vote_now
          this.company_name = res.data.data[0].ptitle
          this.percant = res.data.data[0].vote_now/2

        }
      })


        setTimeout(function () {
          that.getvote()
        }, 1000)


    },
  },
  mounted () {
    this.getplist()
     // this.getvote();
    // this.modalMap.modalVisible = true;
    // this.creatQrCode();
  }
}
</script>
<style lang="less">
.background{
  width: 100%;
  height: 100%;
  background-image: url('https://ljtc.tcrc.com.cn/upload-image/back1.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
}

.front{
  z-index:1;
  position: absolute;
}
</style>
